export default "__VITE_ASSET__BaVtY$12__"